"use strict";const r=t=>t.matches(":dir(rtl)")?"rtl":"ltr";export default r;
//# sourceMappingURL=getEffectiveDir.js.map
